(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bandelle-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bandelle-size-dialog'))customElements.define('bandelle-size-dialog',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const o={signal:this.abort.signal};this.querySelectorAll('.bd-source-notes').forEach(notes=>{if(notes.dataset.dualUnits)return;notes.dataset.dualUnits='true';const w=document.createTreeWalker(notes,NodeFilter.SHOW_TEXT);let n;while((n=w.nextNode()))n.textContent=n.textContent.replace(/(\d+(?:\.\d+)?)(?:[–-](\d+(?:\.\d+)?))?\s*cm\b/g,(_,a,b)=>a+(b?'–'+b:'')+' cm ('+(Number(a)/2.54).toFixed(1)+(b?'–'+(Number(b)/2.54).toFixed(1):'')+' in)')});this.trigger=this.querySelector('.bd-fit-trigger');this.dialog=this.querySelector('dialog');this.trigger.addEventListener('click',()=>{this.dialog.showModal();this.trigger.setAttribute('aria-expanded','true')},o);this.querySelector('[data-fit-close]').addEventListener('click',()=>this.dialog.close(),o);this.dialog.addEventListener('close',()=>{this.trigger.setAttribute('aria-expanded','false');this.trigger.focus()},o);this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},o)}
 disconnectedCallback(){this.abort?.abort()}
});
  } catch(e) { console.error(e); }
})();

})();
